import React from "react";
import { useTranslation } from "react-i18next";
import Chip from '@mui/material/Chip';
import Divider from '@mui/material/Divider';

import { Button } from "components/Shared/Inputs";

import "./AcceptCIReferral.scss";

interface AcceptCIReferralProps {
    onBackClick: () => void;
}

export const AcceptCIReferral: React.FC<AcceptCIReferralProps> = ({ onBackClick }) => {
    const { t } = useTranslation('criticalIncident', { useSuspense: false });

    return (
        <div className="accept-ci-referral-root">
            <div className="illustration">
                <picture>
                    <source srcSet="/images/Chrysanthemum_Green_SideView_BH_m_0-1.png" media="(max-width: 768px)" />
                    <source srcSet="/images/Chrysanthemum_Green_SideView_BH_m_0.png" media="(min-width: 769px)" />
                    <img src="/images/Chrysanthemum_Green_SideView_BH_m_0.png" alt="Flower illustration" width="344" />
                </picture>
                <Chip className="status_chip" label={t('pending')} />
            </div>
            <div className="bottom-half">
                <h1>{t('availability_confirmed')}</h1>
                <div dangerouslySetInnerHTML={{ __html: t('case_accepted_instruction')}} />
                <div className="back_button_container">
                    <Button variant="outline" onClick={onBackClick} fullWidth>{t('back_to_referral_overview')}</Button>
                </div>
                <Divider />
                <section>
                    <div className="contact_info_section" dangerouslySetInnerHTML={{ __html: t('availability_changes_contact_cac') }} />
                </section>
            </div>
        </div>
    );
};
